import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(() => ({}));
export default StyledBox;
